const cache = Symbol('cache');

const STATUS_LOADING = 'STATUS_LOADING';
const STATUS_ERROR = 'STATUS_ERROR';
const STATUS_LOADED = 'STATUS_LOADED';

export class ScriptLoader {
  constructor() {
    this[cache] = {};
  }

  loadScript(url){
    return new Promise((resolve, reject) => {
      const loadedScripts = this[cache];
      const loader = loadedScripts[url];
      if(!loader) {                                       //New script
        //----Create Script Tag----
        const script = document.createElement('script');

        //----Create Loader----
        const newLoader = {
          dom: script,
          error: null,
          status: STATUS_LOADING,
          errorCallbacks: [reject],
          successCallbacks: [resolve]
        };
        loadedScripts[url] = newLoader;

        //----Set script content----
        script.src = url;
        script.async = true;
        document.body.append(script);

        //----Handle Errors----
        script.onerror = (error) => {
          const currentLoader = loadedScripts[url];
          currentLoader.error = error;
          currentLoader.status = STATUS_ERROR;
          const errorCallbacks = currentLoader.errorCallbacks;
          errorCallbacks.forEach(callbackFunction => {
            callbackFunction(error);
          });

          //Clear previous callbacks
          currentLoader.errorCallbacks = [];
          currentLoader.successCallbacks = [];
        }

        //----Handle Success----
        script.onload = () => {
          const currentLoader = loadedScripts[url];
          currentLoader.status = STATUS_LOADED;
          const successCallbacks = currentLoader.successCallbacks;
          successCallbacks.forEach(callbackFunction => {
            callbackFunction();
          });
          
          //Clear previous callbacks
          currentLoader.errorCallbacks = [];
          currentLoader.successCallbacks = [];
        }
      } else if (loader.status === STATUS_LOADING) {      //script is still loading
        loader.errorCallbacks.push(reject);
        loader.successCallbacks.push(resolve);
      } else if (loader.status === STATUS_ERROR) {        //loading script has failed
        reject(loader.error);
      } else if (loader.status === STATUS_LOADED) {       //script has been loaded
        resolve();
      }
    });
  }
}

const ScriptLoaderInstance = new ScriptLoader;
export default ScriptLoaderInstance;